import React from 'react';
import { motion } from 'framer-motion';
import { useInView } from 'react-intersection-observer';
import { Link } from 'react-router-dom';
export const AboutPage = () => {
  const [visionRef, visionInView] = useInView({
    triggerOnce: true,
    threshold: 0.1
  });
  const [teamRef, teamInView] = useInView({
    triggerOnce: true,
    threshold: 0.1
  });
  const [advisoryRef, advisoryInView] = useInView({
    triggerOnce: true,
    threshold: 0.1
  });
  const [projectRef, projectInView] = useInView({
    triggerOnce: true,
    threshold: 0.1
  });
  const [goalsRef, goalsInView] = useInView({
    triggerOnce: true,
    threshold: 0.1
  });
  const [whyNowRef, whyNowInView] = useInView({
    triggerOnce: true,
    threshold: 0.1
  });
  const [visionLongRef, visionLongInView] = useInView({
    triggerOnce: true,
    threshold: 0.1
  });
  const [fundingRef, fundingInView] = useInView({
    triggerOnce: true,
    threshold: 0.1
  });
  const sectionVariants = {
    hidden: {
      opacity: 0,
      y: 50
    },
    visible: {
      opacity: 1,
      y: 0
    }
  };
  const leadershipTeam = [{
    name: 'Azn Alahah',
    title: 'Founder & Executive Director',
    bio: 'Azn Alahah is a microbiome researcher with over 15 years of experience in gut health and therapeutic development. Previously led research teams at leading pharmaceutical companies focusing on microbiome-targeted therapies.',
    image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/pHWegwvKPXZhGe1ZwtEHkB/Generated_Image_September_17%2C_2025_-_8_14PM~2.png'
  }, {
    name: 'Dr. Michael Patel',
    title: 'Director of Research',
    bio: "With a background in molecular biology and bioinformatics, Dr. Patel oversees the institute's research initiatives and clinical trials. His work has been published in leading scientific journals on microbiome analysis.",
    image: 'https://images.unsplash.com/photo-1560250097-0b93528c311a?ixlib=rb-1.2.1&auto=format&fit=crop&w=800&q=80'
  }, {
    name: 'Dr. Aisha Nkosi',
    title: 'Head of Clinical Trials',
    bio: 'Dr. Nkosi brings expertise in clinical trial design and implementation, with a focus on translating research into practical therapeutic applications. She previously led global clinical research programs at major research institutions.',
    image: 'https://images.unsplash.com/photo-1551836022-d5d88e9218df?ixlib=rb-1.2.1&auto=format&fit=crop&w=800&q=80'
  }, {
    name: 'Dr. James Rivera',
    title: 'Director of Communications & Outreach',
    bio: "With a dual background in microbiology and science communication, Dr. Rivera leads the institute's efforts to translate complex scientific findings into accessible information for consumers, practitioners, and policymakers.",
    image: 'https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?ixlib=rb-1.2.1&auto=format&fit=crop&w=800&q=80'
  }];
  const advisoryBoard = [{
    name: 'Dr. Elena Rodriguez',
    title: 'Advisory Board Chair, Former FDA Director',
    bio: 'Dr. Rodriguez brings over 20 years of regulatory experience from the FDA, specializing in supplement safety and efficacy standards. She provides strategic guidance on regulatory compliance and industry best practices.',
    image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/bdK1yZFgwXxoxPtmyosLs2/dre.jpg'
  }, {
    name: 'Prof. David Kim',
    title: 'Microbiome Research Pioneer, Stanford University',
    bio: 'A leading researcher in microbiome science with over 200 published papers. Prof. Kim advises on cutting-edge research methodologies and helps establish scientific protocols for our studies.',
    image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/6s1W4f2FSw76P52WWnnNio/ddk.png'
  }, {
    name: 'Dr. Maria Santos',
    title: 'Clinical Nutrition Expert, Harvard Medical School',
    bio: 'An internationally recognized expert in nutritional medicine and functional foods. Dr. Santos guides our research on the intersection of nutrition, microbiome health, and therapeutic applications.',
    image: 'https://images.unsplash.com/photo-1559839734-2b71ea197ec2?ixlib=rb-1.2.1&auto=format&fit=crop&w=800&q=80'
  }, {
    name: 'Dr. Robert Thompson',
    title: 'Pharmaceutical Industry Veteran',
    bio: 'Former Chief Scientific Officer at major pharmaceutical companies, Dr. Thompson provides expertise in drug development processes and helps bridge the gap between supplements and pharmaceutical-grade therapeutics.',
    image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/8bNrS6RL9yis2Hqy37oYcY/drm.jpg'
  }];
  return <div className="bg-white w-full" data-id="element-54" data-mp="35ctx9s21zadc">
      {/* Hero Section */}
      <section className="relative pt-32 pb-20 bg-gray-50" data-id="element-55" data-mp="18jilyhv50k70">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-56" data-mp="18gmrj3ii0dnb">
          <div className="text-center" data-id="element-57" data-mp="13l7ci88r8bpb">
            <h1 className="text-4xl font-bold text-gray-900 sm:text-5xl md:text-6xl" data-id="element-58" data-mp="1c0wn0mnap58s">
              About Ukweli Institute
            </h1>
            <p className="mt-6 max-w-3xl mx-auto text-xl text-gray-600" data-id="element-59" data-mp="1g1gizmw4u2tc">
              Setting the gold standard for evidence-based wellness and
              therapeutic science
            </p>
          </div>
        </div>
      </section>
      {/* Vision & Mission Section */}
      <section className="py-16 bg-white" data-id="element-60" data-mp="t2c1rb834u32">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-61" data-mp="t3n3z6lvtts2">
          <motion.div ref={visionRef} initial="hidden" animate={visionInView ? 'visible' : 'hidden'} variants={sectionVariants} transition={{
          duration: 0.8
        }} className="grid grid-cols-1 md:grid-cols-2 gap-12" data-id="element-62" data-mp="x2vvs5xd3hkz">
            <div className="bg-blue-50 p-8 rounded-lg shadow-sm" data-id="element-63" data-mp="2dh47t6kia8id">
              <h2 className="text-2xl font-bold text-gray-900 mb-4" data-id="element-64" data-mp="2igh3mgtcupx3">
                Our Vision
              </h2>
              <div className="w-16 h-1 bg-blue-600 mb-6" data-id="element-65" data-mp="1ss1u7kn1wi8c"></div>
              <p className="text-gray-700" data-id="element-66" data-mp="1nts25iwmhxqy">
                To become the global benchmark for evidence-based wellness and
                therapeutic science by bridging the gap between consumer
                products, academic research, and clinical translation. A
                central, independent research institute that tests and verifies
                health product claims with serious science, but also
                communicates results in a clear, public-facing way that captures
                attention.
              </p>
            </div>
            <div className="bg-blue-50 p-8 rounded-lg shadow-sm" data-id="element-67" data-mp="1jtpw6xjuui5v">
              <h2 className="text-2xl font-bold text-gray-900 mb-4" data-id="element-68" data-mp="1f16js3wwlt2n">
                Our Mission
              </h2>
              <div className="w-16 h-1 bg-blue-600 mb-6" data-id="element-69" data-mp="rau6ediw344o"></div>
              <p className="text-gray-700" data-id="element-70" data-mp="md0xvdu45y18">
                The Institute is committed to advancing microbiome and
                therapeutics research with the same rigor as pharmaceutical
                sciences. By integrating cutting-edge microbiome analysis, AI,
                therapeutic validation, and transparent communication, the
                Institute will lead the movement to separate credible science
                from marketing hype in the $120B+ wellness and supplement
                industry.
              </p>
            </div>
          </motion.div>
        </div>
      </section>
      {/* Leadership Team Section */}
      <section className="py-16 bg-gray-50" data-id="element-71" data-mp="3lp6wlt1kadlf">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-72" data-mp="37pxshrqmr9xt">
          <motion.div ref={teamRef} initial="hidden" animate={teamInView ? 'visible' : 'hidden'} variants={sectionVariants} transition={{
          duration: 0.8
        }} className="text-center mb-12" data-id="element-73" data-mp="37po2w59hz4sn">
            <h2 className="text-3xl font-bold text-gray-900 mb-4" data-id="element-74" data-mp="20dozfoy29x60">
              Leadership Team
            </h2>
            <div className="w-20 h-1 bg-blue-600 mx-auto mb-6" data-id="element-75" data-mp="2rxuffts1tcu4"></div>
            <p className="max-w-3xl mx-auto text-lg text-gray-600" data-id="element-76" data-mp="2n02q97isg4tm">
              Our team of world-class scientists and researchers are dedicated
              to advancing microbiome science and therapeutic development.
            </p>
          </motion.div>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8" data-id="element-77" data-mp="3aq6oezd7jcd8">
            {leadershipTeam.map((leader, index) => <motion.div key={leader.name} initial="hidden" animate={teamInView ? 'visible' : 'hidden'} variants={sectionVariants} transition={{
            duration: 0.8,
            delay: index * 0.2
          }} className="bg-white rounded-lg overflow-hidden shadow-md" data-id="element-78" data-mp="36q4n4rbdwkyh" data-mpi={index}>
                <img src={leader.image} alt={leader.name} className="w-full h-64 object-cover" data-id="element-79" data-mp="3pm4kkhn4sgpg" />
                <div className="p-6" data-id="element-80" data-mp="5rr8ypb1alxy">
                  <h3 className="text-xl font-semibold text-gray-900" data-id="element-81" data-mp="5ssx9vh294xm">
                    {leader.name === 'Azn Alahah' ? <Link to="/profile" className="hover:text-blue-600 transition-colors" data-id="element-82" data-mp="et8x8uylhtxq">
                        {leader.name}
                      </Link> : leader.name}
                  </h3>
                  <p className="text-blue-600 mb-3" data-id="element-83" data-mp="thvc6vkb8jof">{leader.title}</p>
                  <p className="text-gray-600 text-sm" data-id="element-84" data-mp="yh86u2hfav1k">{leader.bio}</p>
                </div>
              </motion.div>)}
          </div>
        </div>
      </section>
      {/* Advisory Board Section */}
      <section className="py-16 bg-white" data-id="element-85" data-mp="17hd59n4n2j3l">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-86" data-mp="17ift1m6o05fa">
          <motion.div ref={advisoryRef} initial="hidden" animate={advisoryInView ? 'visible' : 'hidden'} variants={sectionVariants} transition={{
          duration: 0.8
        }} className="text-center mb-12" data-id="element-87" data-mp="2a7hgjdimpwcp">
            <h2 className="text-3xl font-bold text-gray-900 mb-4" data-id="element-88" data-mp="2ovuhkowkq5e2">
              Advisory Board
            </h2>
            <div className="w-20 h-1 bg-blue-600 mx-auto mb-6" data-id="element-89" data-mp="2swea1f67cktv"></div>
            <p className="max-w-3xl mx-auto text-lg text-gray-600" data-id="element-90" data-mp="2xvr86w2ixebr">
              Our institute is guided by leading scientists and experts who
              provide strategic direction and ensure scientific excellence.
            </p>
          </motion.div>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8" data-id="element-91" data-mp="37sds9in101cq">
            {advisoryBoard.map((advisor, index) => <motion.div key={advisor.name} initial="hidden" animate={advisoryInView ? 'visible' : 'hidden'} variants={sectionVariants} transition={{
            duration: 0.8,
            delay: index * 0.2
          }} className="bg-white rounded-lg overflow-hidden shadow-md" data-id="element-92" data-mp="1dg5ulxjbl6d9" data-mpi={index}>
                <img src={advisor.image} alt={advisor.name} className="w-full h-64 object-cover" data-id="element-93" data-mp="3d03gqsj930ft" />
                <div className="p-6" data-id="element-94" data-mp="9ilklicubhv8">
                  <h3 className="text-xl font-semibold text-gray-900" data-id="element-95" data-mp="9jmwfp1ok8e0">
                    {advisor.name}
                  </h3>
                  <p className="text-blue-600 mb-3" data-id="element-96" data-mp="4hnt2f5xxbh2">{advisor.title}</p>
                  <p className="text-gray-600 text-sm" data-id="element-97" data-mp="3voql18tlrlsc">{advisor.bio}</p>
                </div>
              </motion.div>)}
          </div>
        </div>
      </section>
      {/* Project Overview Section */}
      <section className="py-16 bg-gray-50" data-id="element-98" data-mp="2k91w4bwsgcow">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-99" data-mp="2lrsf274qz4i3">
          <motion.div ref={projectRef} initial="hidden" animate={projectInView ? 'visible' : 'hidden'} variants={sectionVariants} transition={{
          duration: 0.8
        }} className="mb-12" data-id="element-100" data-mp="2lsldmktjynp5">
            <h2 className="text-3xl font-bold text-gray-900 mb-4" data-id="element-101" data-mp="2hong2ejvlky7">
              Project Overview
            </h2>
            <div className="w-20 h-1 bg-blue-600 mb-6" data-id="element-102" data-mp="22z7q30s65jjk"></div>
            <p className="text-lg text-gray-700 mb-6" data-id="element-103" data-mp="27t2icslub6u9">
              We are creating an independent, science-driven research laboratory
              designed to be the "Consumer Reports meets MythBusters" of the
              wellness and supplement industry. The institute functions as a
              credible central authority that evaluates probiotics,
              nutraceuticals, and functional health products with scientific
              rigor and transparency.
            </p>
            <p className="text-lg text-gray-700" data-id="element-104" data-mp="15ey4u0qg8nws">
              The brand identity under consideration includes authoritative
              names like the Ukweli Institute for Microbiome Research &
              Therapeutics, which conveys trust, global perspective, and
              scientific authority.
            </p>
          </motion.div>
          <motion.div ref={projectRef} initial="hidden" animate={projectInView ? 'visible' : 'hidden'} variants={sectionVariants} transition={{
          duration: 0.8,
          delay: 0.2
        }} data-id="element-105" data-mp="1agx87am6vktq">
            <h3 className="text-2xl font-bold text-gray-900 mb-4" data-id="element-106" data-mp="1y3vifqjptwj7">
              Core Mission
            </h3>
            <p className="text-lg text-gray-700 mb-8" data-id="element-107" data-mp="1t7ey77fn02be">
              To establish evidence-based standards for the $120B+ U.S. wellness
              and supplement industry (projected to hit $182B by 2034). The lab
              bridges the gap between biohacker-driven supplement culture and
              traditional pharma-level clinical trials by running reliable,
              reproducible studies that consumers, clinicians, and investors can
              trust.
            </p>
          </motion.div>
        </div>
      </section>
      {/* Key Goals Section */}
      <section className="py-16 bg-white" data-id="element-108" data-mp="f4fjlrkp9ocz">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-109" data-mp="f7juf7so7icm">
          <motion.div ref={goalsRef} initial="hidden" animate={goalsInView ? 'visible' : 'hidden'} variants={sectionVariants} transition={{
          duration: 0.8
        }} className="mb-12" data-id="element-110" data-mp="3doxjfik2bijn">
            <h2 className="text-3xl font-bold text-gray-900 mb-4" data-id="element-111" data-mp="3rnx8usfeg1gv">Key Goals</h2>
            <div className="w-20 h-1 bg-blue-600 mb-6" data-id="element-112" data-mp="12w349rrdc36t"></div>
          </motion.div>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-113" data-mp="16wn0mt44b2rw">
            <motion.div ref={goalsRef} initial="hidden" animate={goalsInView ? 'visible' : 'hidden'} variants={sectionVariants} transition={{
            duration: 0.8,
            delay: 0.1
          }} className="bg-white p-8 rounded-lg shadow-sm" data-id="element-114" data-mp="16yzpzrc7gfez">
              <h3 className="text-xl font-bold text-gray-900 mb-4" data-id="element-115" data-mp="2dmhjvts0daww">
                1. Scientific Leadership
              </h3>
              <ul className="text-gray-700 space-y-3 list-disc pl-5" data-id="element-116" data-mp="28pr99lyz37iv">
                <li data-id="element-117" data-mp="23obprycg192l">
                  Develop and test protocols like the Microbiota Reset & Biofilm
                  Management Program
                </li>
                <li data-id="element-118" data-mp="1uoyauq5jvsah">
                  Investigate the role of compounds like NAC, tomato
                  phytonutrients, and spore-forming probiotics
                </li>
                <li data-id="element-119" data-mp="3tzpxyln26h72">
                  Provide validated consumer-ready protocols for gut health and
                  systemic wellness
                </li>
              </ul>
            </motion.div>
            <motion.div initial="hidden" animate={goalsInView ? 'visible' : 'hidden'} variants={sectionVariants} transition={{
            duration: 0.8,
            delay: 0.2
          }} className="bg-white p-8 rounded-lg shadow-sm" data-id="element-120" data-mp="bzu3g5a9al8s">
              <h3 className="text-xl font-bold text-gray-900 mb-4" data-id="element-121" data-mp="vpe9x92vfhdn">
                2. Transparency & Consumer Protection
              </h3>
              <ul className="text-gray-700 space-y-3 list-disc pl-5" data-id="element-122" data-mp="zqzi4h4gn7hi">
                <li data-id="element-123" data-mp="lsja8muv3axs">
                  Test and benchmark supplements for efficacy, safety, and
                  bioavailability
                </li>
                <li data-id="element-124" data-mp="qsxl0cnukyzi">
                  Publish clear reports so consumers and practitioners can
                  separate hype from reality
                </li>
                <li data-id="element-125" data-mp="3bhv33bj7wh0c">
                  Operate with an open-science approach—building public trust by
                  showing methodology and outcomes
                </li>
              </ul>
            </motion.div>
            <motion.div initial="hidden" animate={goalsInView ? 'visible' : 'hidden'} variants={sectionVariants} transition={{
            duration: 0.8,
            delay: 0.3
          }} className="bg-white p-8 rounded-lg shadow-sm" data-id="element-126" data-mp="2yxy2aviklzgj">
              <h3 className="text-xl font-bold text-gray-900 mb-4" data-id="element-127" data-mp="2g7yk8sl5dkmm">
                3. Global Research Network
              </h3>
              <ul className="text-gray-700 space-y-3 list-disc pl-5" data-id="element-128" data-mp="2tzmu0p7xbx0f">
                <li data-id="element-129" data-mp="2p8n07su3pv25">
                  Recruit accomplished researchers and scientists with
                  competitive compensation
                </li>
                <li data-id="element-130" data-mp="21hhif84losp7">
                  Build an international network of labs and collaborators to
                  validate findings across geographies
                </li>
                <li data-id="element-131" data-mp="1byxdym1o75b7">
                  Position the institute as a standard-setting body for
                  functional wellness science
                </li>
              </ul>
            </motion.div>
          </div>
        </div>
      </section>
      {/* Why Now & Long-Term Vision Section */}
      <section className="py-16 bg-gray-50" data-id="element-132" data-mp="1py6wvth9gdiv">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-133" data-mp="1pvu5kppm4qt5">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-12" data-id="element-134" data-mp="1uvyqqt1gu9pp">
            <motion.div ref={whyNowRef} initial="hidden" animate={whyNowInView ? 'visible' : 'hidden'} variants={sectionVariants} transition={{
            duration: 0.8
          }} data-id="element-135" data-mp="1yyd7n7lkqzec">
              <h2 className="text-2xl font-bold text-gray-900 mb-4" data-id="element-136" data-mp="28q946e80ihgg">
                Why Now?
              </h2>
              <div className="w-16 h-1 bg-blue-600 mb-6" data-id="element-137" data-mp="2imm0zkyutbff"></div>
              <ul className="text-gray-700 space-y-4" data-id="element-138" data-mp="2imucb8fbw8oi">
                <li className="flex items-start" data-id="element-139" data-mp="6zs9i036atuw">
                  <div className="flex-shrink-0 h-6 w-6 flex items-center justify-center rounded-full bg-blue-100 text-blue-600 mr-3" data-id="element-140" data-mp="6x5zltst829i">
                    <svg className="h-4 w-4" fill="currentColor" viewBox="0 0 20 20" data-id="element-141" data-mp="3t67c0ci98ve2">
                      <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" data-id="element-142" data-mp="3o9qkd8bujyw8" />
                    </svg>
                  </div>
                  <p data-id="element-143" data-mp="b1dr1yqnjwbf">
                    <strong data-id="element-144" data-mp="azsz8gvq2rh9">Market Need:</strong> The U.S. wellness and
                    supplement industry is projected to grow from $121.6B in
                    2024 to $182.8B by 2034, yet most companies rely on
                    surface-level studies or "biohacker" lore.
                  </p>
                </li>
                <li className="flex items-start" data-id="element-145" data-mp="2ubn8jqtwh5lk">
                  <div className="flex-shrink-0 h-6 w-6 flex items-center justify-center rounded-full bg-blue-100 text-blue-600 mr-3" data-id="element-146" data-mp="2par51edgnlgo">
                    <svg className="h-4 w-4" fill="currentColor" viewBox="0 0 20 20" data-id="element-147" data-mp="2la79ugcg6rx6">
                      <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" data-id="element-148" data-mp="3d13bslwyzc5o" />
                    </svg>
                  </div>
                  <p data-id="element-149" data-mp="2z8x4zqfpihiw">
                    <strong data-id="element-150" data-mp="2z7m3xydnbnvh">Scientific Gap:</strong> Few organizations run
                    independent labs; most rely on scattered public data,
                    creating inconsistent results and consumer mistrust.
                  </p>
                </li>
                <li className="flex items-start" data-id="element-151" data-mp="3563rw136j4k">
                  <div className="flex-shrink-0 h-6 w-6 flex items-center justify-center rounded-full bg-blue-100 text-blue-600 mr-3" data-id="element-152" data-mp="82xwutdgwbac">
                    <svg className="h-4 w-4" fill="currentColor" viewBox="0 0 20 20" data-id="element-153" data-mp="d0zd76jidwi4">
                      <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" data-id="element-154" data-mp="m307bujg42fk" />
                    </svg>
                  </div>
                  <p data-id="element-155" data-mp="10qlcdtzvsbq4">
                    <strong data-id="element-156" data-mp="10qtq1o3tvl2d">Global Opportunity:</strong> An institute operating
                    internationally can become the trusted global authority on
                    microbiome & therapeutics validation.
                  </p>
                </li>
              </ul>
            </motion.div>
            <motion.div ref={visionLongRef} initial="hidden" animate={visionLongInView ? 'visible' : 'hidden'} variants={sectionVariants} transition={{
            duration: 0.8,
            delay: 0.2
          }} data-id="element-157" data-mp="35vpku1y09w33">
              <h2 className="text-2xl font-bold text-gray-900 mb-4" data-id="element-158" data-mp="3asg1aqdq2tp1">
                Long-Term Vision
              </h2>
              <div className="w-16 h-1 bg-blue-600 mb-6" data-id="element-159" data-mp="3kkcaawhck481"></div>
              <p className="text-gray-700 mb-4" data-id="element-160" data-mp="3kk2ir4gnlp08">
                The project aims to become the gold standard authority in
                wellness and microbiome science — equivalent to how UL certifies
                electronics or Consumer Reports guides purchasing decisions.
              </p>
              <p className="text-gray-700 mb-4" data-id="element-161" data-mp="246cdvvhpmwpj">
                Within 5–10 years, the institute could:
              </p>
              <ul className="text-gray-700 space-y-2 list-disc pl-5" data-id="element-162" data-mp="1z9dm3jlir1ui">
                <li data-id="element-163" data-mp="epi77y1z3mtd">Establish internationally recognized testing protocols</li>
                <li data-id="element-164" data-mp="jn076yy0irp8">Lead the shift toward evidence-based wellness products</li>
                <li data-id="element-165" data-mp="5x6jijy8udh3">
                  Launch spin-off consumer products backed by real science,
                  bridging the gap between supplements and medical-grade
                  therapeutics
                </li>
              </ul>
            </motion.div>
          </div>
        </div>
      </section>
      {/* Funding & Sustainability Section */}
      <section className="py-16 bg-white" data-id="element-166" data-mp="vh46s3zndn7">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-167" data-mp="3j3oo0451q3sj">
          <motion.div ref={fundingRef} initial="hidden" animate={fundingInView ? 'visible' : 'hidden'} variants={sectionVariants} transition={{
          duration: 0.8
        }} className="text-center mb-12" data-id="element-168" data-mp="3j5jdzwv6cm3h">
            <h2 className="text-3xl font-bold text-gray-900 mb-4" data-id="element-169" data-mp="1lb2jpw6r5voc">
              Funding & Sustainability
            </h2>
            <div className="w-20 h-1 bg-blue-600 mx-auto mb-6" data-id="element-170" data-mp="rn4w0n34ub5q"></div>
          </motion.div>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-171" data-mp="mobhqsg0ug4i">
            <motion.div initial="hidden" animate={fundingInView ? 'visible' : 'hidden'} variants={sectionVariants} transition={{
            duration: 0.8,
            delay: 0.1
          }} className="bg-white p-8 rounded-lg shadow-sm text-center" data-id="element-172" data-mp="mqo8nv3rc0tp">
              <div className="inline-flex items-center justify-center h-16 w-16 rounded-full bg-blue-100 text-blue-600 mb-4" data-id="element-173" data-mp="3xajy7qn0qmj">
                <svg className="h-8 w-8" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" data-id="element-174" data-mp="3v5pur2g89km2">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 8c-1.657 0-3 .895-3 2s1.343 2 3 2 3 .895 3 2-1.343 2-3 2m0-8c1.11 0 2.08.402 2.599 1M12 8V7m0 1v8m0 0v1m0-1c-1.11 0-2.08-.402-2.599-1M21 12a9 9 0 11-18 0 9 9 0 0118 0z" data-id="element-175" data-mp="3m62rsc7uo6qw" />
                </svg>
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-2" data-id="element-176" data-mp="1hxotkppzc8iz">
                Hybrid Funding Model
              </h3>
              <p className="text-gray-700" data-id="element-177" data-mp="1mw8hgvo4vudz">
                Create a hybrid funding model with venture backing, grants, and
                partnerships with supplement companies seeking credibility.
              </p>
            </motion.div>
            <motion.div initial="hidden" animate={fundingInView ? 'visible' : 'hidden'} variants={sectionVariants} transition={{
            duration: 0.8,
            delay: 0.2
          }} className="bg-white p-8 rounded-lg shadow-sm text-center" data-id="element-178" data-mp="1wo5w6cecp4hg">
              <div className="inline-flex items-center justify-center h-16 w-16 rounded-full bg-blue-100 text-blue-600 mb-4" data-id="element-179" data-mp="s49164wskw8d">
                <svg className="h-8 w-8" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" data-id="element-180" data-mp="15uceu7hlvhm7">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M15 10l4.553-2.276A1 1 0 0121 8.618v6.764a1 1 0 01-1.447.894L15 14M5 18h8a2 2 0 002-2V8a2 2 0 00-2-2H5a2 2 0 00-2 2v8a2 2 0 002 2z" data-id="element-181" data-mp="d8t1nkdg084l" />
                </svg>
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-2" data-id="element-182" data-mp="1yj06qlwv158q">
                Media Platform
              </h3>
              <p className="text-gray-700" data-id="element-183" data-mp="1tkgey4vl4z8g">
                Launch a media platform (YouTube/Podcasts) akin to MythBusters,
                showcasing the science behind testing, trials, and myth
                debunking.
              </p>
            </motion.div>
            <motion.div initial="hidden" animate={fundingInView ? 'visible' : 'hidden'} variants={sectionVariants} transition={{
            duration: 0.8,
            delay: 0.3
          }} className="bg-white p-8 rounded-lg shadow-sm text-center" data-id="element-184" data-mp="32iopbwc6ogxd">
              <div className="inline-flex items-center justify-center h-16 w-16 rounded-full bg-blue-100 text-blue-600 mb-4" data-id="element-185" data-mp="34w3c6lpbdea">
                <svg className="h-8 w-8" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" data-id="element-186" data-mp="3qfvob3zhcfmk">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z" data-id="element-187" data-mp="mru0b57v7jya" />
                </svg>
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-2" data-id="element-188" data-mp="246u91gvx9opj">
                Brand Moat
              </h3>
              <p className="text-gray-700" data-id="element-189" data-mp="31qovodmgx6ou">
                Build a brand moat where credibility itself becomes the key
                business asset, establishing Ukweli Institute as the trusted
                authority in the field.
              </p>
            </motion.div>
          </div>
        </div>
      </section>
    </div>;
};